import React from 'react';

const FooterStick = () => {
  return <hr className='my-6 border-gray-200 sm:mx-auto  lg:my-8' />;
};

export default FooterStick;
